import React, { useState } from 'react';
import { Modal } from './ui/Modal';

/**
 * Asks for the password of a saved connection that has none stored.
 *
 * The alternative — which is what happened before this existed — is connecting
 * with an empty password and showing whatever the server says. That reads as
 * "the server rejected your credentials" when the truth is that the app never
 * asked for them.
 *
 * The password is handed to the caller and not kept here; storing it is opt-in
 * via the checkbox, and that decision belongs to the caller too.
 */
export default function DbPasswordPromptModal({ open, connectionLabel, user, onSubmit, onClose }) {
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(false);

  if (!open) return null;

  const submit = () => {
    onSubmit({ password, remember });
    // Not held any longer than the submit itself.
    setPassword('');
    setRemember(false);
  };

  return (
    <Modal
      isOpen
      onClose={onClose}
      title="Password required"
      subtitle={
        user ? `${user}@${connectionLabel} has no saved password` : `${connectionLabel} has no saved password`
      }
      size="sm"
    >
      <div>
        <input
          type="password"
          autoFocus
          className="dbm-filter-input dbm-password-input"
          value={password}
          placeholder="Password"
          aria-label="Password"
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              submit();
            }
          }}
        />
        <label className="dbm-find-check" style={{ marginTop: 10 }}>
          <input
            type="checkbox"
            className="checkbox-brand"
            checked={remember}
            onChange={(e) => setRemember(e.target.checked)}
          />
          Remember this password
        </label>
        <div className="modal-footer-row" style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 14 }}>
          <button
            type="button"
            onClick={onClose}
            className="px-3 py-1.5 text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors modern-button-secondary text-sm"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={submit}
            className="px-3 py-1.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors modern-button text-sm"
          >
            Connect
          </button>
        </div>
      </div>
    </Modal>
  );
}
